<template>
  <div
    data-aos="fade-down"
    data-aos-offset="200"
    class="pills pills-accent"
    :style="styles()"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PillsAccent',
  props: {
    left: Number,
    right: Number,
    top: Number,
    bottom: Number
  },
  methods: {
    styles () {
      return {
        ...(this.left !== undefined && { left: `${this.left}px` }),
        ...(this.right !== undefined && { right: `${this.right}px` }),
        ...(this.top !== undefined && { top: `${this.top}px` }),
        ...(this.bottom !== undefined && { bottom: `${this.bottom}px` })
      };
    }
  }
};
</script>>
